/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgReportPackage = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M22 22H4v-3h2v1h14V6h-1V4h3z" />
        <path d="M10 5a5 5 0 1 1 0 10 5 5 0 0 1 0-10zM9 7.174A2.999 2.999 0 0 0 10 13a3 3 0 0 0 2.94-3.595L9 11.764zm2 1.062.914-.547A2.994 2.994 0 0 0 11 7.174z" />
        <path d="M18 18H2V2h16zM4 16h12V4H4z" />
      </g>
    </g>
  </Icon>
);
export { SvgReportPackage as ReportPackage };
